import { createMiddleware } from "@tanstack/react-start";

/**
 * Same contract as the generated `attachSupabaseAuth`, but the Supabase client
 * (and the ~100 KiB auth SDK behind it) is imported lazily so it never lands in
 * the initial bundle of public marketing pages, which make no authenticated
 * server-function calls.
 */
export const attachSupabaseAuthLazy = createMiddleware({ type: "function" }).client(
  async ({ next }) => {
    const { supabase } = await import("@/integrations/supabase/client");
    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;
    return next({
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
  },
);
